/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Series_Pipeline_NoteInputs */

const en_us2_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some of these assessments were computed by an earlier version of the calculation, so the differences between them are not shown. They come back once the history is recomputed.`)
};

const pt_br2_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte destas avaliações foi calculada por uma versão anterior do cálculo, então as diferenças entre elas não são mostradas. Elas voltam quando o histórico for recalculado.`)
};

const es_419_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunas de estas evaluaciones se calcularon con una versión anterior del cálculo, así que no se muestran las diferencias entre ellas. Vuelven a aparecer cuando el historial se recalcule.`)
};

const pt_pt2_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas destas avaliações foram calculadas por uma versão anterior do cálculo, por isso as diferenças entre elas não são mostradas. Voltam quando o histórico for recalculado.`)
};

const fr_fr2_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certaines de ces évaluations ont été calculées par une version antérieure du calcul, donc leurs écarts ne sont pas affichés. Ils réapparaissent quand l'historique est recalculé.`)
};

const de_de2_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige dieser Messungen wurden mit einer früheren Version der Berechnung ermittelt, daher werden die Unterschiede nicht angezeigt. Sie erscheinen wieder, sobald der Verlauf neu berechnet ist.`)
};

const it_it2_body_assessment_series_pipeline_note = /** @type {(inputs: Body_Assessment_Series_Pipeline_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcune di queste valutazioni sono state calcolate da una versione precedente del calcolo, quindi le differenze tra loro non vengono mostrate. Torneranno quando lo storico sarà ricalcolato.`)
};

/**
* | output |
* | --- |
* | "Some of these assessments were computed by an earlier version of the calculation, so the differences between them are not shown. They come back once the hist..." |
*
* @param {Body_Assessment_Series_Pipeline_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_series_pipeline_note = /** @type {((inputs?: Body_Assessment_Series_Pipeline_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Series_Pipeline_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_series_pipeline_note(inputs)
	if (locale === "es-419") return es_419_body_assessment_series_pipeline_note(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_series_pipeline_note(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_series_pipeline_note(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_series_pipeline_note(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_series_pipeline_note(inputs)
	return en_us2_body_assessment_series_pipeline_note(inputs)
});
export { body_assessment_series_pipeline_note as "body-assessment.series_pipeline_note" }